(function () {
    'use strict';

    function findAPartnerController($scope, $log, searchConfigurationDataService,
        sessionDataService) {
        var vm = this;
        vm.config = {};
        vm.sessionData = {};
        vm.results = [];
        vm.showResults = false;
        vm.attributes = {};
        vm.searchConfiguration = {};
        vm.project = {};

        vm.initialPartnerIds = [];

        vm.pageSizes = [5, 10, 15, 20, 25];

        $scope.init = function (project, extension) {
            vm.project = project;
            vm.extension = extension;

            vm.config = searchConfigurationDataService.loadEntitiesSearch(extension.EntitySearchIndex,
                project.Id)
                .then(function (data) {
                    vm.config = data;
                });

            vm.sessionData = sessionDataService.loadSession().then(function (data) {
                vm.sessionData = data;
            });

            vm.initialPartnerConnectionIds = extension.PartnerConnections.map(function (item) {
                return item.EntityId;
            });
        }

        vm.togglePartnerIntroduction = function (partner, partnerConnections) {
            var partnerIds = partnerConnections.map(function (item) {
                return item.EntityId;
            });
            var indexOfPartnerToAdd = partnerIds.indexOf(partner.Id);
            if (indexOfPartnerToAdd !== -1) {
                partnerIds.splice(indexOfPartnerToAdd, 1);
                partner.isSelected = false;
            } else {
                partnerConnections.push({
                    EntityId: partner.Id,
                    Status: 'Requested',
                    LastActivityDate: new Date(),
                    Partner: partner
                });
                partner.isSelected = true;
            }
        }
    }

    findAPartnerController.$inject = ['$scope', '$log', 'searchConfigurationDataService',
        'sessionDataService'];

    angular.module('ecap.workflow').controller('findAPartnerController', findAPartnerController);
})();
